import { _ } from "libs";

import React from "react";
import ProfileForm from "./profileForm";
import { Profile } from "../../types";

type Props = {
	profile: Profile;
	onChange: Function;
};

export function Step1({ profile, onChange }: Props) {
	return (
		<div className="box onboardingStep1">
			<div className="boxLeader">
				<h2>{_("onboarding.profileSection.heading")}</h2>
				<div className="illustration player_filing_form" />
			</div>
			<div className="boxContent">
				<ProfileForm profile={profile} onChange={onChange} />
			</div>
		</div>
	);
}

export default Step1;
